import makeVerticalLayoutHook from '../../../../hooks/makeVerticalLayoutHook/makeVerticalLayoutHook';

export default makeVerticalLayoutHook({
  menuButtonHeight: 55,
  tourControlsHeight: 430,
  switchToLandscapeThreshold: 50,
});
